import useSWR from 'swr'
import { client } from '@lib/api'

export type MigrationStatus = 'MIGRATION_INITIATED' |'INITIATED' | 'PROCESSING' | 'JETTON_RETURN_INITIATED' | 'JETTON_RETURN_SUCCESS' | 'JETTON_RETURN_FAILED' | 'SC_MINT_INITIATED' | 'SC_MINT_FAILED' | 'COMPLETED_SC_MINT_SUCCESS' | 'COMPLETED_NO_JS'

export type MigrationStatusResponse = {
  user_id: string
  status: MigrationStatus
}

// Helper function to check if migration is in progress and should lock the user
export const isMigrationInProgress = (status?: MigrationStatus): boolean => {
  if (!status) return false

  // Migration is in progress if it's in any of these states
  const inProgressStates: MigrationStatus[] = [
    'JETTON_RETURN_INITIATED',
    'JETTON_RETURN_SUCCESS',
    'JETTON_RETURN_FAILED',
    'SC_MINT_INITIATED',
    'SC_MINT_FAILED'
  ]

  return inProgressStates.includes(status)
}

// Helper function to check if migration is completed
export const isMigrationCompleted = (status?: MigrationStatus): boolean => {
  if (!status) return false
  return status === 'COMPLETED_SC_MINT_SUCCESS' || status === 'COMPLETED_NO_JS'
}

export const useMigrationStatus = (refreshInterval?: number) => {
  const { data, error, isLoading, mutate } = useSWR('/wallet/migrations/status', async (url: string) => {
    try {
      const response = await client.doGet(url) as MigrationStatusResponse
      return response
    } catch (error) {
      throw error
    }
  }, {
    revalidateOnFocus: false,
    revalidateOnReconnect: false,
    dedupingInterval: 0,
    refreshInterval: refreshInterval
  })

  return {
    data,
    error,
    isLoading,
    isError: !!error,
    mutate
  }
}
